import {
  faCarOn,
  faCheck,
  faLock,
  faUserCheck,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBContainer,
  MDBInput,
  MDBRow,
} from "mdbreact";
import React, { useState, useEffect } from "react";
import { Bounce, ToastContainer, toast } from "react-toastify";
import Axios from "axios";
import WarningBox from "../components/WarningBox";
import { useDispatch } from "react-redux";
import { setStatus } from "../features/sales/salesSlice";
const ReleaseTicket = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const dispatch = useDispatch();
  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const [frm, setValues] = useState({
    code: props.parentcode,

    printed: false,
  });

  const notify = (message) => {
    toast(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold blue-text",
    });
  };

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;
      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };
  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    closeticket();
  }
  const closeticket = () => {
    const data = frm;

    Axios.post(props.apiServer + "/closeticket", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });
          dispatch(setStatus(false));
          notify(res.data.message);
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  const openticket = () => {
    const data = frm;

    Axios.post(props.apiServer + "/openticket", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });
          dispatch(setStatus(true));
          notify(res.data.message);
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  const loadticket = () => {
    Axios.get(
      props.apiServer + "/loadtransactionsalesmain/?code=" + props.parentcode,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,

            code: props.parentcode,

            printed: res.data.printed,
          });
          dispatch(setStatus(res.data.printed));
        } else {
          ClearFields();
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  const ClearFields = () => {
    setValues({
      ...frm,

      code: props.parentcode,

      printed: false,
    });
  };

  useMountEffect(checkAdminAccess);

  useEffect(() => {
    loadticket();
  }, [frm]);
  return (
    <MDBCard>
      <MDBCardHeader className="cloudy-knoxville-gradient">
        <span
          className="h5-responsive blue-text"
          style={{
            fontFamily: "Montserrat",
            fontWeight: "400",
          }}
        >
          <span className="blue-text">
            <FontAwesomeIcon icon={faUserCheck} />
          </span>
          &nbsp;Ticket Releasing
        </span>
      </MDBCardHeader>
      <MDBCardBody>
        <form className="needs-validation" onSubmit={submitHandler} noValidate>
          {frm.printed === true ? (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="12" className="text-center brown-text">
                  <h5 className="font-weight-bold h5-responsive">
                    <FontAwesomeIcon
                      icon={faLock}
                      size="2x"
                      className="brown-text"
                    >
                      {" "}
                    </FontAwesomeIcon>
                    &nbsp; TICKET RELEASED
                  </h5>
                  <br />
                </MDBCol>
              </MDBRow>
              {isAdmin === 0 ? (
                <>
                  <MDBRow>
                    <MDBCol md="12" className="text-center">
                      {" "}
                      <p>
                        This ticket has been completed already. <br />
                        If you want to re-open this ticket, please contact the
                        Administrator.
                      </p>
                      <br />
                    </MDBCol>
                  </MDBRow>
                </>
              ) : (
                <>
                  <MDBRow>
                    <MDBCol md="12" className="text-center">
                      {" "}
                      <p>
                        This ticket has been completed already. <br />
                        If you want to re-open this ticket, please check the
                        important reminder below:
                      </p>
                      <br />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol md="12">
                      <h4 className="red-text font-weight-bold text-center">
                        <FontAwesomeIcon icon={faWarning}></FontAwesomeIcon>
                        &nbsp;Important Reminder
                      </h4>

                      <p className="text-center">
                        Opening this ticket will enable the encoding of Charges,
                        <br />
                        Recommendations, Payments, and other details related to
                        this ticket. <br />
                        Please click{" "}
                        <span className="font-weight-bold red-text">
                          "Reopen Ticket"
                        </span>{" "}
                        if you want to continue reopening this ticket.
                      </p>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow>
                    <MDBCol md="12" className="text-center">
                      <MDBBtn
                        className="blue lighten-1"
                        onClick={() => openticket()}
                      >
                        Re-open Ticket
                      </MDBBtn>
                    </MDBCol>
                  </MDBRow>
                </>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="12" className="text-center">
                  <h5 className="font-weight-bold h5-responsive blue-text">
                    <FontAwesomeIcon
                      icon={faCarOn}
                      size="2x"
                      className="blue-text"
                    >
                      {" "}
                    </FontAwesomeIcon>
                    ACTIVE TICKET
                  </h5>
                  <br />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="12">
                  <h4 className="red-text font-weight-bold text-center">
                    <FontAwesomeIcon icon={faWarning}></FontAwesomeIcon>
                    &nbsp;Important Reminder
                  </h4>

                  <p className="text-center">
                    Closing this ticket will disable the encoding of Charges,
                    <br />
                    Recommendations, Payments, and other details related to this
                    ticket. <br />
                    <br />
                    Please click{" "}
                    <span className="font-weight-bold red-text">
                      "Close Ticket"
                    </span>{" "}
                    if you want to continue closing this ticket.
                  </p>
                  <br />
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="12" className="text-center">
                  <MDBBtn
                    className="blue lighten-1"
                    onClick={() => closeticket()}
                  >
                    Close Ticket
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            </React.Fragment>
          )}
        </form>
      </MDBCardBody>
      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
    </MDBCard>
  );
};

export default ReleaseTicket;
